package org.zq.astrock_ai.ui.research.gushi.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import org.zq.astrock_ai.ui.research.gushi.StockColors
import org.zq.astrock_ai.ui.research.gushi.adaptiveDialogWidth
import org.zq.astrock_ai.ui.research.gushi.data.ResearchBackup

@Composable
fun ResearchBackupDialog(
    onDismiss: () -> Unit,
    onImported: () -> Unit,
    onExportReady: (String) -> Unit,
) {
    var importDraft by remember { mutableStateOf("") }
    var message by remember { mutableStateOf<String?>(null) }
    val shape = RoundedCornerShape(14.dp)
    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .adaptiveDialogWidth(440.dp)
                .heightIn(max = 520.dp)
                .background(Color.White, shape)
                .border(BorderStroke(1.dp, StockColors.Border), shape)
                .padding(18.dp),
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    "本机备份",
                    color = StockColors.TextPrimary,
                    fontWeight = FontWeight.Bold,
                    fontSize = 17.sp,
                    modifier = Modifier.weight(1f),
                )
                Text(
                    "关闭",
                    color = StockColors.PrimaryBlue,
                    fontSize = 13.sp,
                    modifier = Modifier.clickable(onClick = onDismiss).padding(6.dp),
                )
            }
            Spacer(Modifier.height(6.dp))
            Text(
                "导出自选/持仓/流水/分组/扫描偏好，可复制到其它设备粘贴导入（云同步前身）。",
                color = StockColors.TextSecondary,
                fontSize = 11.sp,
            )
            Spacer(Modifier.height(12.dp))
            Text(
                "导出备份",
                color = Color.White,
                fontWeight = FontWeight.SemiBold,
                fontSize = 13.sp,
                modifier = Modifier
                    .background(StockColors.PrimaryBlue, RoundedCornerShape(10.dp))
                    .clickable {
                        onExportReady(ResearchBackup.exportText())
                        onDismiss()
                    }
                    .padding(horizontal = 14.dp, vertical = 8.dp),
            )
            Spacer(Modifier.height(14.dp))
            Text("粘贴备份 JSON 导入", color = StockColors.TextPrimary, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
            Spacer(Modifier.height(6.dp))
            BasicTextField(
                value = importDraft,
                onValueChange = { importDraft = it },
                textStyle = TextStyle(
                    color = StockColors.TextPrimary,
                    fontSize = 11.sp,
                    fontFamily = FontFamily.Monospace,
                ),
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(min = 120.dp, max = 200.dp)
                    .background(Color(0xFFF8F9FB), RoundedCornerShape(8.dp))
                    .padding(10.dp)
                    .verticalScroll(rememberScrollState()),
            )
            Spacer(Modifier.height(8.dp))
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    "导入并覆盖",
                    color = Color.White,
                    fontWeight = FontWeight.SemiBold,
                    fontSize = 13.sp,
                    modifier = Modifier
                        .background(
                            if (importDraft.isNotBlank()) StockColors.UpRed else Color(0xFF9CA3AF),
                            RoundedCornerShape(10.dp),
                        )
                        .clickable(enabled = importDraft.isNotBlank()) {
                            val result = ResearchBackup.importText(importDraft)
                            message = result.getOrElse { it.message ?: "导入失败" }
                            if (result.isSuccess) onImported()
                        }
                        .padding(horizontal = 14.dp, vertical = 8.dp),
                )
                Spacer(Modifier.width(10.dp))
                if (message != null) {
                    Text(message!!, color = StockColors.TextSecondary, fontSize = 12.sp)
                }
            }
        }
    }
}
